export const LoaderInfo = (text, title='') => {
    document.getElementById('loader-text').innerHTML = text
    document.getElementById('loader').classList.add('show')
    document.getElementById('loader').classList.remove('hide')
}

export const CloseLoaderInfo = () => {
    document.getElementById('loader-text').innerHTML = ''
    document.getElementById('loader').classList.add('hide')
    document.getElementById('loader').classList.remove('show')
}